var map = {
	"./QQ.svg": "ac36",
	"./audio-play.svg": "6dbb",
	"./audio-stop.svg": "b11d",
	"./avatar-upload.svg": "47d1",
	"./changeMenu.svg": "5e1b",
	"./close.svg": "1434",
	"./down.svg": "6849",
	"./download.svg": "ec55",
	"./emoji-icon.svg": "279a",
	"./folder.svg": "d541",
	"./help.svg": "f1b9",
	"./image.svg": "797cf",
	"./index-avg-time.svg": "d539",
	"./index-chat-ticket.svg": "661c",
	"./index-no-reply.svg": "f4dcf",
	"./index-ticket.svg": "1699",
	"./index-visitor.svg": "4b4b",
	"./leaveMsg.svg": "2155",
	"./manService.svg": "7c34",
	"./mobile.svg": "0333",
	"./navbar_download.svg": "3537",
	"./navbar_info.svg": "0950",
	"./notice.svg": "9c75",
	"./offline-status.svg": "6725",
	"./online-status.svg": "8195",
	"./onlineService.svg": "ab43",
	"./question.svg": "cb54",
	"./reportChat.svg": "e3b9b",
	"./reportChatTime.svg": "c234",
	"./reportLeaveMsg.svg": "741b",
	"./reportReply.svg": "03fc",
	"./reportVisitor.svg": "e0cd",
	"./robotMsg.svg": "bd65",
	"./service.svg": "a5b6",
	"./sidebar-current.svg": "81f4",
	"./sidebar-history.svg": "21f1",
	"./sidebar-home.svg": "9632",
	"./sidebar-report.svg": "7f38",
	"./sidebar-robot.svg": "306a",
	"./sidebar-robot1.svg": "bb7e",
	"./sidebar-service.svg": "1bb1",
	"./sidebar-setting.svg": "664a",
	"./sidebar-statistics.svg": "85ff",
	"./sidebar-team.svg": "013b",
	"./up.svg": "36c9",
	"./video.svg": "23f5",
	"./video_play.svg": "d38e",
	"./visitorNum.svg": "e090",
	"./wechat.svg": "c49a",
	"./weibo.svg": "ccc0",
	"./workOrder.svg": "f710"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47be";